import HeaderComponent from "../components/HeaderComponent"
import FooterComponent from "../components/FooterComponent"
import LoginComponent from "../components/LoginComponent"

const LoginPage = () => {
    return (
        <>
            <HeaderComponent/>
            <LoginComponent/>
            <FooterComponent/>
        </>
    )
}

export default LoginPage